import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const usageDetails = [
    { id: 'frequency90Day', name: 'Frequency 90D' },
    { id: 'frequency6Month', name: 'Frequency 6M' },
    { id: 'matchPercentageYTD', name: 'Match Percentage YTD' },
    { id: 'frequencyYTD', name: 'Frequency YTD' },
    { id: 'frequencyPreviousYTD', name: 'Frequency Previous YTD' },
    { id: 'yoyChangePercentage', name: 'YOY Change %' },
    { id: 'prevFrequency1Year', name: `Frequency ${currentYear - 1}` },
    { id: 'prevFrequency2Year', name: `Frequency ${currentYear - 2}` },
    { id: 'prevFrequency3Year', name: `Frequency ${currentYear - 3}` },
];

const UsageDetailSelector = () => {
    const dispatch = useDispatch();
    const selectedCodeUsageDetail = useSelector(
        (state) => state.daylight.selectedCodeUsageDetail
    );
    const usageDetailChangeHandler = (string) =>
        dispatch(actions.daylight.setSelectedCodeUsageDetail(string));

    return (
        <th scope="col" className="col col-medium">
            <select
                className="p-1 rounded w-100"
                value={selectedCodeUsageDetail}
                onChange={(e) => usageDetailChangeHandler(e.target.value)}>
                {usageDetails.map((usageDetail) => (
                    <option key={usageDetail.id} value={usageDetail.id}>
                        {usageDetail.name}
                    </option>
                ))}
            </select>
        </th>
    );
};

export default UsageDetailSelector;
